import styled from "styled-components";


export const Flex = styled.div<{extras?:string}>`
display: flex;
${p=>p.extras}
`